import { render, staticRenderFns } from "./userOrder.vue?vue&type=template&id=499c2997&scoped=true"
import script from "./userOrder.vue?vue&type=script&lang=js"
export * from "./userOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499c2997",
  null
  
)

export default component.exports